import { render } from "./TherapyReviewManagement.vue?vue&type=template&id=485ed714&scoped=true"
import script from "./TherapyReviewManagement.vue?vue&type=script&lang=js"
export * from "./TherapyReviewManagement.vue?vue&type=script&lang=js"

import "./TherapyReviewManagement.vue?vue&type=style&index=0&id=485ed714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485ed714"]])

export default __exports__